export default "__VITE_ASSET__Db0DqYcM__"